import { render, staticRenderFns } from "./SelectList.vue?vue&type=template&id=4f20a6bb&scoped=true&"
import script from "./SelectList.vue?vue&type=script&lang=js&"
export * from "./SelectList.vue?vue&type=script&lang=js&"
import style0 from "./SelectList.vue?vue&type=style&index=0&id=4f20a6bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f20a6bb",
  null
  
)

export default component.exports